module.exports = __webpack_public_path__ + "media/src/fonts/GothamPro-Medium-b7dd0a0ad50052dfa9b0e846dfb576e5.woff2";